export default {
    name: 'Account',

    props: {
        operation: {
            type: Object,
            required: true
        }
    }
};
